import Vue from 'vue'

// Google Identity Services (new API)
const loadGoogleIdentityServices = () => {
  return new Promise((resolve) => {
    if (window.google && window.google.accounts) {
      resolve(window.google)
      return
    }

    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => resolve(window.google)
    document.head.appendChild(script)
  })
}

// Initialize Google Identity Services
loadGoogleIdentityServices()

// Add to Vue prototype for easy access
Vue.prototype.$googleAuth = {
  load: loadGoogleIdentityServices,
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID || ''
}

export default { loadGoogleIdentityServices }

